import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';

/** @deprecated  Exporting the component so that it can be used in other files. */
export default ExpansionPanelActions;
